import { HIDCodeType } from './HIDCodeType';

export default function formatHIDCode(code: HIDCodeType): string {
  return `${code.code1}-${code.code2}-${code.code3}-${code.code4}`.toUpperCase();
}
